export function omit<T extends object, K extends keyof T>(
  obj: T,
  keys: K[],
): Pick<T, Exclude<keyof T, K>> {
  const cloneObj = { ...obj };
  keys.forEach((key) => delete cloneObj[key]);

  return cloneObj;
}
